/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

export type MixtureAlgorithm =
    (typeof MixtureAlgorithm)[keyof typeof MixtureAlgorithm];

export const MixtureAlgorithm = {
    /** None */
    None: "None",
    /** BridgingPrinciples */
    BridgingPrinciples: "BridgingPrinciples",
    /** WeightedAverage */
    WeightedAverage: "WeightedAverage",
} as const;
